module.exports = __webpack_public_path__ + "static/img/sharePage.5b173f0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/sharePage.webp
// module id = KZka
// module chunks = 0